import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import DetailModalWrapper from '../../../components/DetailModalWrapper'
import Button from '../../../components/UI/Button'
import Input from '../../../components/UI/Input'
import Loader from '../../../components/UI/Loader'
import { partiesInputsData } from '../../../constants/partiesPage'
import { useEditPartyMutation, useLazyGetPartyByIdQuery } from '../../../store/parties/perties.api'
import s from './index.module.scss'
import dateFormat from 'dateformat'
import SliderModal from '../../../components/UI/SliderModal'
import { IParty } from '../../../models/models'
import { schema } from './schema'
import { getPartyFilesLinks } from '../../../helpers'

interface IProps {
	id: string | number
	closeHandler: () => void
}

const EditPartiesModal = ({ id, closeHandler }: IProps) => {
	const [getParty, { isError }] = useLazyGetPartyByIdQuery()
	const [editParty, { isLoading: partyEditing, error }] = useEditPartyMutation()

	const [filesLinks, setFilesLinks] = useState<string[]>([])
	const [isLoading, setIsLoading] = useState<boolean>(true)

	const {
		register,
		handleSubmit,
		getValues,
		formState: { errors },
	} = useForm<IParty>({
		resolver: yupResolver(schema),
		defaultValues: async () =>
			getParty(id)
				.unwrap()
				.then((res: any) => {
					setFilesLinks(getPartyFilesLinks(res))
					setIsLoading(false)
					return {
						...res,
						primePrice: !!res.primePrice ? res.primePrice / 100 : res.primePrice,
					}
				}),
	})

	const submitHandler = (data: IParty) => {
		editParty({
			id,
			data: { ...data, primePrice: data.primePrice * 100 },
		})
			.unwrap()
			.then(() => closeHandler())
	}

	return (
		<DetailModalWrapper closeHandler={closeHandler}>
			<h3 className={s.title}>Перевірка даних</h3>

			{isLoading && <Loader />}
			{isError && <div style={{ textAlign: 'center' }}>Щось пішло не так :(</div>}

			{!isLoading && !isError && (
				<form onSubmit={handleSubmit(submitHandler)}>
					<div className={s.formWrapper}>
						<div>
							{partiesInputsData.map((i) => (
								<Input
									key={i.name}
									type={i.type}
									register={register}
									name={i.name}
									label={i.placeholder}
									placeholder={i.placeholder}
									errors={errors}
									step={['density', 'mass', 'temperature', 'volumeStableDegree', 'primePrice'].includes(i.name) ? 0.01 : 1}
								/>
							))}
						</div>
						<div>
							<Input type="text" value={dateFormat(getValues('datetime'), 'dd.mm.yyyy')} label={'Дата'} disabled />
							<Input type="text" value={dateFormat(getValues('datetime'), 'HH:MM')} label={'Час'} disabled />
							<Input type="text" register={register} name={'number'} label={'Номер транспорту'} disabled />
						</div>
					</div>

					{filesLinks?.length > 0 && (
						<div className={s.filesWrapper}>
							<div>Прикріплені файли:</div>
							<SliderModal files={filesLinks} />
						</div>
					)}

					{error && 'data' in error && <p className={s.error}>{error?.data?.message}</p>}

					<Button variant={'filled'} type={'submit'} className={s.btn} disabled={isLoading || partyEditing}>
						Затвердити
					</Button>
				</form>
			)}
		</DetailModalWrapper>
	)
}

export default EditPartiesModal
